import React from "react";

const DescriptionItem = ({ label, value }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center mb-3">
      <span className="font-medium text-gray-700 w-32 md:w-40">{label}:</span>
      <span className="text-gray-800">{value || ""}</span>
    </div>
  );
};

const LiveClassDetails = ({ data, setIsModalOpen }) => {
  return (
    <div className="bg-white rounded-lg w-full">
      <DescriptionItem label="Title" value={data.title} />
      <DescriptionItem label="Description" value={data.description} />
      <DescriptionItem label="Instructor" value={data.instructor} />
      <DescriptionItem
        label="Date"
        value={new Date(data.date).toLocaleDateString()}
      />
      <DescriptionItem label="Time" value={data.time} />
      <DescriptionItem label="Duration" value={data.duration} />
      {/* <DescriptionItem
        label="Meeting Link"
        value={
          data.meetingLink ? (
            <Link
              to={
                data.meetingLink.startsWith("http")
                  ? data.meetingLink
                  : `https://${data.meetingLink}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Join
            </Link>
          ) : (
            "N/A"
          )
        }
      />
      <DescriptionItem
        label="Recording Link"
        value={
          data.recordingLink ? (
            <button
              className="text-blue-600 hover:underline"
              onClick={() => setIsModalOpen(true)}
            >
              Watch
            </button>
          ) : (
            "N/A"
          )
        }
      /> */}
    </div>
  );
};

export default LiveClassDetails;
